export default __webpack_public_path__ + "ecc0d5684d1f0b8b5811cd791008b535.svg";